import { Layout } from '@glu/core';

import template from './genericLayout.hbs';

export default Layout.extend({
  template,

  collectionEvents: {
    'grid:filter:change': 'showLoader',
    'grid:filters:clear': 'showLoader'
  },

  initialize() {
    this.listenTo(this, {
      'grid:contentRendered': this.hideLoader,
      'grid:content:empty': this.hideLoader
    });
  },

  setHeader(header) {
    this.headerView = header;
  },

  setFooter(footer) {
    this.footerView = footer;
  },

  setContent(view) {
    this.contentView = view;
  },

  setManageColumns(view) {
    this.manageColumnsView = view;
  },

  onRender() {
    if (this.headerView) {
      this.header.show(this.headerView);
    }

    if (this.manageColumnsView) {
      this.manageColumns.show(this.manageColumnsView);
    }

    if (this.contentView) {
      this.content.show(this.contentView);
    }

    if (this.footerView) {
      this.footer.show(this.footerView);
    }
  },

  showLoader() {
    if (this.options.showLoaderOnFilter) {
      this.$('.loader').removeClass('hidden');
      this.$('.content').addClass('loading');
    }
  },

  hideLoader() {
    if (this.options.showLoaderOnFilter) {
      this.$('.loader').addClass('hidden');
      this.$('.content').removeClass('loading');
    }
  }
});
